module.exports = __webpack_public_path__ + "media/application/images/cyber-forum/texture@2x-7f93b7c47e3976b0bcd75b7f6f1e541a.jpg";